/* Nutsack Nuts — ATC image enrichment + cart total profiling (redirect-safe)
   --------------------------------------------------------------------------
   Requires product-page Liquid map that defines:
     window.__klvVariantImageMap[variantId] = 'https://...';
     window.__klvProductImageURL = 'https://...';
     window.__klvProductImage    = window.__klvProductImageURL; // alias
   Include just before </body> with defer (cache-bust while testing if needed).
*/

var __NS_FREE_SHIP_THRESHOLD = 59;

/** ---------- HELPERS ---------- **/
async function __nsUpdateCartValueProfile({ retries = 8, delay = 200 } = {}) {
  for (let i = 0; i < retries; i++) {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!res.ok) throw new Error('cart.js not ok');
      const data = await res.json();
      const total = ((data && data.total_price) || 0) / 100;
      const gap   = Math.max(0, __NS_FREE_SHIP_THRESHOLD - total);

      if (total > 0 || i === retries - 1) {
        if (window.klaviyo && typeof klaviyo.identify === 'function') {
          klaviyo.identify({ last_cart_value: total, gap_to_free_ship: gap });
        } else {
          (window._learnq = window._learnq || []).push(['identify', { last_cart_value: total, gap_to_free_ship: gap }]);
        }
        return total;
      }
    } catch (e) { /* retry */ }
    await new Promise(r => setTimeout(r, delay));
  }
}

// Debounce so multiple hooks don’t spam identify
function __nsTriggerCartProfileUpdate() {
  if (window.__nsCartValueLock) return;
  window.__nsCartValueLock = true;
  __nsUpdateCartValueProfile().finally(() => {
    setTimeout(() => { window.__nsCartValueLock = false; }, 800);
  });
}

/** ---------- MARK ATC PENDING BEFORE NAV ---------- **/
// If the theme submits a normal form (causing a full page load), mark a flag we can read on the next page.
document.addEventListener('submit', function(e){
  const form = e.target && e.target.closest("form[action*='/cart/add']");
  if (form) { try { sessionStorage.setItem('__ns_atc_pending', '1'); } catch(e){} }
}, true);

// Some themes bind Add buttons; mark on click too (harmless if fetch/XHR route also fires)
document.addEventListener('click', function(e){
  const btn = e.target && e.target.closest("button[name='add'], [type='submit'][name='add']");
  if (btn) { try { sessionStorage.setItem('__ns_atc_pending', '1'); } catch(e){} }
}, true);

/** ---------- POST-ADD HOOKS (AJAX) ---------- **/
// Fetch hook: when /cart/add succeeds (AJAX), update immediately
(function hookFetch(ns, originalFetch) {
  if (!originalFetch) return;
  ns.fetch = function () {
    const p = originalFetch.apply(this, arguments);
    p.then(function (res) {
      try {
        if (res && res.ok && String(res.url || '').indexOf('/cart/add') !== -1) {
          __nsTriggerCartProfileUpdate();
          try { sessionStorage.setItem('__ns_atc_pending', ''); } catch(e){} // clear flag if we handled it
        }
      } catch (e) {}
    });
    return p;
  };
})(window, window.fetch);

// XHR hook: covers themes/apps using XMLHttpRequest
(function hookXHR() {
  if (!window.XMLHttpRequest) return;
  const open = XMLHttpRequest.prototype.open;
  const send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__nsURL = url;
    return open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    this.addEventListener('load', function () {
      try {
        if (this.status >= 200 && this.status < 300 && String(this.__nsURL || '').indexOf('/cart/add') !== -1) {
          __nsTriggerCartProfileUpdate();
          try { sessionStorage.setItem('__ns_atc_pending', ''); } catch(e){}
        }
      } catch (e) {}
    });
    return send.apply(this, arguments);
  };
})();

/** ---------- NEXT-PAGE (REDIRECT) SAFETY NET ---------- **/
// If we navigated away right after Add to Cart, finish the job on the next page.
window.addEventListener('pageshow', function(){
  try {
    const pending = sessionStorage.getItem('__ns_atc_pending');
    const onCart  = location.pathname.indexOf('/cart') === 0;
    if (pending === '1' || onCart) {
      __nsTriggerCartProfileUpdate();
      sessionStorage.removeItem('__ns_atc_pending');
    }
  } catch(e){}
});

/** ---------- ENRICH ONSITE "ADDED TO CART" WITH IMAGE ---------- **/
(function ensureKlaviyoAtcImage(){
  function wrap(){
    var k = (window._learnq = window._learnq || []);
    if (k.push && k.push.__nsImgWrap) return;

    var orig = k.push.bind(k);
    function wrappedPush(){
      try{
        var cmd = arguments[0];
        if (Array.isArray(cmd) && cmd[0] === 'track' && cmd[1] === 'Added to Cart' && cmd[2]){
          var evt = cmd[2];

          // variant from ?variant=...
          var variantId = null;
          try{
            if (evt.AddedItemURL){
              var u = new URL(evt.AddedItemURL, location.origin);
              variantId = u.searchParams.get('variant');
            }
          }catch(e){}

          // image: variant -> product fallback (support both names)
          var url = null;
          if (variantId && window.__klvVariantImageMap && window.__klvVariantImageMap[variantId]){
            url = window.__klvVariantImageMap[variantId];
          }
          if (!url){
            url = window.__klvProductImageURL || window.__klvProductImage || null;
          }

          if (url && !evt.AddedItemImageURL){
            evt.AddedItemImageURL = url;
            cmd[2] = evt;
          }
        }
      }catch(e){}
      return orig.apply(this, arguments);
    }
    wrappedPush.__nsImgWrap = true;
    k.push = wrappedPush;
  }

  wrap();
  // Re-wrap for late overrides (app embeds)
  var attempts = 0;
  var iv = setInterval(function(){
    attempts++;
    var k = window._learnq;
    if (!k || !k.push || !k.push.__nsImgWrap) wrap();
    if (attempts > 60) clearInterval(iv); // ~15s
  }, 250);
  window.addEventListener('load', wrap);
})();